<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/crossing">“In Crossing”: Commemorative Poem by Katy Whittingham</a></p>
<p class="toc"><a href="#/introduction">Introduction: The Yin and Yang of History</a></p>
<p class="toc1"><span href="#/chapter01" title="Link target outside of Sample">1. The British Are Coming</span></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. <i>Nimrod</i>: The Scourge of Buzzards Bay</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Settlement of Wareham</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. War along the Coast</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Sails, Whales and Nails: Industry in Wareham</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Submission—Never</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. On to Wareham</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. The Attack</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The End of the Hunter</span></p>
<p class="toc1"><span href="#/appendix01" title="Link target outside of Sample">Appendix I. <i>Nimrod</i> Timeline</span></p>
<p class="toc"><span href="#/appendix02" title="Link target outside of Sample">Appendix II. Letter from Wareham, 1814</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?49ba0dd2